<template lang="pug">
  v-container
    v-layout(row wrap)
      v-flex(xs12)
        v-text-field(label=" Cardholder Name" v-model="name" required @keyup="updateCustomer()") 
      v-flex(xs12)
        v-text-field(label="Collected by" v-model="collector" required @keyup="updateCustomer()")
      v-flex(xs12)
        v-text-field(label="Email" type="email" v-model="email" required @keyup="updateCustomer()") 
      v-flex(xs12)
        v-text-field(label="Phone" type="number" v-model="phone" @keyup="updateCustomer()" :rules="[rules.phone]") 
      
      v-menu(
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")
        
              v-text-field(
                slot="activator"
                v-model="dob"
                label="Date of birth"
                readonly
                persistent-hint
                prepend-icon="event")
              v-date-picker(v-model="date" no-title @input="menu1 = false " :max="maxDate" )
      v-flex(xs12) Available collection time is between {{event.startTime}} and {{event.endTime}}
      v-menu(
              ref="menu3"
              :close-on-content-click="false"
              v-model="menu3"
              :nudge-right="40"
              :return-value.sync="pickupTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              )

              v-text-field(
                slot="activator"
                v-model="pickupTime"
                label="Collection Time"
                prepend-icon="access_time"
                :background-color = "tcolor"
                :hint = "res"
                readonly)
              v-time-picker(
                v-if="menu3"
                v-model="pickupTime"
                format="24hr"
                full-width
                :min="event.startTime"
                :max="event.endTime"
                @change="$refs.menu3.save(pickupTime);")
      v-flex.text-xs-right(xs12)
        v-btn(color="orange" :disabled="formFilled" @click="next()") Next

</template>
<script>
export default {
  props:['step'],
  data:()=>({
    
    name:" ",
    collector: "",
    phone:" ",
    email:" ",
    dob:null,
    date: null,
    dateFormatted:'',
    menu1: false,
    menu3: false,
    pickupTime:null,
    res:'',
    tcolor:'',
    rules:{
      phone: value=> (value.length >= 7 ) || 'Phone number must have at least 7 digits'
    }
  }),
  watch: {
      date (val) {
        //console.log("looging at date")
        this.dob = this.formatDate(this.date)
        this.updateCustomer()
      },
      pickupTime (val) {
        this.updateCustomer()
      },
      step (val){
        if (val == 2){
          this.fillForm()
        }
      }
    },
  computed:{
    event(){
      let that = this
      let selectedEvent = this.$store.state.selectedEvent
      let event=[]
      event = this.$store.state.events.filter(e=>{
                return e.id == selectedEvent
              })
      return event[0]
    },
    maxDate(){
      let today = new Date()
      let day = (today.getFullYear()-18).toString() + '-' + (today.getMonth()+1).toString() + '-' + today.getDate().toString()
      return day
    },
    formFilled(){
      if ((this.name != undefined || this.name != null )&& (this.email != undefined || this.email != null)){
        if (this.name.trim() != "" && this.email.trim() != "" && 
            this.dob != null && this.pickupTime != null && this.phone.trim() != "" && this.phone.trim().length > 6){
          return false
        }else{
          return true
        }
      }else{return true}
    }
  },
  mounted(){
    //console.log("customer details mounted", this.cust)
    //this.cust = this.$store.state.customer
    // 
  },
  methods:{
    updateCustomer(){
      let cust = {
        name: this.name,
        email: this.email,
        dob:this.dob,
        phone: this.phone,
        collectionTime: this.pickupTime,
        collector: this.collector
      }
      this.$store.dispatch('updateCustomer', cust)
    },
    validateTime(){
      if(Object.keys(this.event).length>0){
        if (this.event.startTime < this.pickupTime && this.pickupTime < this.event.endTime){
          this.res = ""
          this.tcolor = ''
        }else{
          // if (this.startTime && this.endTime){
          // this.res = "Start time must be earlier than end time"
          // this.tcolor = "red accent-1"
          // }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    fillForm(){
      if (this.phone ==' ' && (this.$store.state.user.phoneNumber != ' ' && this.$store.state.user.phoneNumber != null)){
        this.phone = this.$store.state.user.phoneNumber
      }else{
        this.phone = ''
      }
      if (this.email==' ' && this.$store.state.user.email != 'null'){
        this.email = this.$store.state.user.email
      }else{
        this.email = ''
      }
      if (this.name==' ' && this.$store.state.user.displayName != ''){
        this.name = this.$store.state.user.displayName
        this.collector = this.$store.state.user.displayName
      }else{
        this.name = ''
      }
      this.updateCustomer()
      this.date = this.maxDate
    },
    next(){
      this.$store.dispatch('saveTempOrder')
      this.$emit('next')
    }
  }
}
</script>
